import script from "./informationdetail.vue?vue&type=script&setup=true&lang=js"
export * from "./informationdetail.vue?vue&type=script&setup=true&lang=js"

import "./informationdetail.vue?vue&type=style&index=0&id=b922739e&lang=scss"
import "./informationdetail.vue?vue&type=style&index=1&id=b922739e&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b922739e"]])

export default __exports__